import { IPoint } from '../point';

export class Line {
  constructor(public point1: IPoint, public point2: IPoint) {
  }
}
